<template>
  <div style="margin-bottom: 12px">
    <a :href="listUrl" style="text-decoration: none; font-weight: 600; color: #1d6bf3"
      >↤ {{ s__("TaskDetail|To Project's Tasks") }}</a
    >
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { s__ } from '@/locale'

const props = defineProps({ projectId: [String, Number], chatId: String, fromId: String })

const listUrl = computed(() => {
  // Try to get stored URL with filters from sessionStorage
  try {
    const storedUrl = sessionStorage.getItem(`taskIndexUrl_${props.projectId}`)
    if (storedUrl) {
      // Parse the stored URL and preserve chat_id/from_id from props if needed
      const storedUrlObj = new URL(storedUrl, window.location.origin)
      const currentParams = new URLSearchParams(storedUrlObj.search)

      // Update chat_id and from_id if provided in props
      if (props.chatId) {
        currentParams.set('chat_id', props.chatId)
      }
      if (props.fromId) {
        currentParams.set('from_id', props.fromId)
      }

      return (
        storedUrlObj.pathname + (currentParams.toString() ? '?' + currentParams.toString() : '')
      )
    }
  } catch (e) {
    console.warn('Failed to get stored task index URL:', e)
  }

  // Fallback to default URL
  const pid = encodeURIComponent(props.projectId)
  const chat = props.chatId ? `?chat_id=${encodeURIComponent(props.chatId)}` : ''
  const from = props.fromId ? `${chat ? '&' : '?'}from_id=${encodeURIComponent(props.fromId)}` : ''
  return `/projects/${pid}/dashboard${chat}${from}`
})
</script>

<style src="../../../styles/forms.css"></style>
